import { WizardStepProps } from '../WizardStepProps';
import React from 'react';
import { ProgressStep } from '../shared/WizardProgress';
import { useWizardStep } from '../useWizardStep';
import { MethodStep } from '../03_methodsStep/MethodStep';
import { ConfirmationDisplay } from './ConfirmationDisplay';
import { ConfirmationNavigationAndSubmission } from './ConfirmationNavigation';
import { FormTemplate } from '../shared/FormTemplate';
import { DssAlert } from './DssAlert';

export const ConfirmationStep: React.FC<WizardStepProps> = ({ wizardFormData, onClose, ...rest }) => {
  const { showPrevious, goBack } = useWizardStep();

  if (showPrevious) {
    return (
      <MethodStep wizardFormData={wizardFormData} onClose={onClose} previous={ProgressStep.CONFIRMATION} {...rest} />
    );
  }
  return (
    <FormTemplate progressStep={ProgressStep.CONFIRMATION} wizardFormData={wizardFormData}>
      <ConfirmationDisplay wizardFormData={wizardFormData} />
      <DssAlert wizardFormData={wizardFormData} />
      <ConfirmationNavigationAndSubmission goBack={goBack} wizardFormData={wizardFormData} onClose={onClose} />
    </FormTemplate>
  );
};
